// src/components/directory/DirectoryHeader.jsx

import React from 'react';
import styles from './DirectoryHeader.module.css';

export default function DirectoryHeader({ onRestart }) {
  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <a href="/" className={styles.logo} onClick={(e) => { e.preventDefault(); onRestart(); }}>
          <span className={styles.logoMark}>◉</span>
          <span className={styles.logoName}>
            Signal<span className={styles.logoAccent}>Post</span>
          </span>
        </a>
        <nav className={styles.nav}>
          <a href="#about">About</a>
          <a href="#how-we-verify">How we verify</a>
          <button className={styles.restartBtn} onClick={onRestart}>
            ← Start over
          </button>
        </nav>
      </div>
    </header>
  );
}
